(() => {
  const init = scope => {
    scope.querySelectorAll('[data-digital-consent-form]').forEach(form => {
      if (form.dataset.consentReady) return;
      form.dataset.consentReady = 'true';
      const root = form.querySelector('[data-digital-consent]');
      const checkbox = form.querySelector('[data-digital-consent-checkbox]');
      const fields = [...form.querySelectorAll('[data-consent-field]')];
      const clear = () => {
        if (checkbox) {
          checkbox.checked = false;
          checkbox.setCustomValidity('');
        }
        fields.forEach(field => field.value = '');
      };
      const record = () => {
        if (!root || !checkbox?.checked) return;
        const products = [...new Set([...form.querySelectorAll('[data-digital-product-id]')]
          .filter(row => Number(row.querySelector('input[name="updates[]"]')?.value) > 0)
          .map(row => row.dataset.digitalProductId))].join(',');
        const timestamp = new Date().toISOString();
        const values = { text: root.dataset.consentText, version: root.dataset.consentVersion,
          products, language: root.dataset.consentLanguage, timestamp, timestamp_source: 'browser' };
        fields.forEach(field => field.value = values[field.dataset.consentField] || '');
        checkbox.value = `${values.text} | record_version=${values.version} | product_ids=${products} | language=${values.language} | consent_timestamp=${timestamp} | timestamp_source=browser`;
        checkbox.setCustomValidity('');
      };
      clear();
      checkbox?.addEventListener('change', () => checkbox.checked ? record() : clear());
      checkbox?.addEventListener('invalid', () => {
        if (!checkbox.checked) checkbox.setCustomValidity(root?.dataset.consentError || '');
      });
      form.querySelectorAll('input[name="updates[]"]').forEach(input => input.addEventListener('input', clear));
      form.addEventListener('submit', event => {
        if (event.submitter?.name === 'update') {
          clear();
          return;
        }
        if (!checkbox) return;
        if (!checkbox.checked) {
          event.preventDefault();
          checkbox.setCustomValidity(root.dataset.consentError);
          checkbox.reportValidity();
          return;
        }
        record();
      });
      window.addEventListener('pageshow', clear);
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
